module.exports = __webpack_public_path__ + "img/shiba-head-level6.4366c129.png";